module.exports = __webpack_public_path__ + "img/twbgscq_icon.30306e30.png";